import { render } from "./AccountPage.vue?vue&type=template&id=707a0c12&ts=true"
import script from "./AccountPage.vue?vue&type=script&lang=ts"
export * from "./AccountPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AccountPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "707a0c12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('707a0c12', __exports__)) {
    api.reload('707a0c12', __exports__)
  }
  
  module.hot.accept("./AccountPage.vue?vue&type=template&id=707a0c12&ts=true", () => {
    api.rerender('707a0c12', render)
  })

}


export default __exports__